export default [{
    id: {
      qqyin: 230625035, // 正式数据 ：230625035
      kugou: 140398663,
      kuwo: 66621909
    },
    imgUrl: 'H5_2.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/000e3Khi1s5nEK.html',
      kugou: 'https://www.kugou.com/singer/793597.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E4%B8%87%E8%83%BD%E9%9D%92%E5%B9%B4/'
    },
    singerId: {
      qqyin: 2722630, // 正式数据 ：230625035
      kugou: 793597,
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  }, 
  {
    id: {
      qqyin: 230625029, // 正式数据 ：230625029
      kugou: 140398677,
      kuwo: 66621935
    },
    imgUrl: 'H5_3.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/003yjqeh2DjBK1.html',
      kugou: 'https://www.kugou.com/singer/6813.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E5%BC%A0%E6%B5%85%E6%BD%9C/'
    },
    singerId: {
      qqyin: '44958',
      kugou: '6813',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  }, 
  {
    id: {
      qqyin: 230625032,
      kugou: 140398676,
      kuwo: 66622104
    },
    imgUrl: 'H5_4.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/004fGiN01g8qTB.html',
      kugou: 'https://www.kugou.com/singer/756538.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E4%B8%89%E5%9B%A7/'
    },
    singerId: {
      qqyin: '1556265',
      kugou: '756538',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625034,
      kugou: 140398674,
      kuwo: 66622060
    },
    imgUrl: 'H5_5.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/002Aim3j203HcP.html',
      kugou: 'https://www.kugou.com/singer/93120.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E5%8F%B8%E5%BE%92%E8%B5%AB%E4%BC%A6/'
    },
    singerId: {
      qqyin: '165834',
      kugou: '93120',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625031,
      kugou: 140398661,
      kuwo: 66622352
    },
    imgUrl: 'H5_6.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/001FpQ4R1yyM5G.html',
      kugou: 'https://www.kugou.com/singer/172717.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E7%8E%8B%E9%AA%9EBoc/'
    },
    singerId: {
      qqyin: '1129358',
      kugou: '172717',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625025,
      kugou: 140398667,
      kuwo: 66622205
    },
    imgUrl: 'H5_7.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/0022Tzrh2afylc.html',
      kugou: 'https://www.kugou.com/singer/182993.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E8%B0%9C%E5%B1%90/'
    },
    singerId: {
      qqyin: '950292',
      kugou: '182993',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625027,
      kugou: 140398685,
      kuwo: 66622187
    },
    imgUrl: 'H5_8.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/003AJiiq08SeTR.html',
      kugou: 'https://www.kugou.com/singer/297979.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E8%89%BE%E5%85%8B%E6%8B%9C%E5%B0%94%20%E5%90%90%E5%B0%94%E5%9C%B0/'
    },
    singerId: {
      qqyin: '63056',
      kugou: '297979',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625028,
      kugou: 140405562,
      kuwo: 66621976
    },
    imgUrl: 'H5_9.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/002xniyG2Zeszn.html',
      kugou: 'https://www.kugou.com/singer/200294.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E6%AC%A7%E9%98%B3%E8%80%80%E8%8E%B9/'
    },
    singerId: {
      qqyin: '2090069',
      kugou: '200294',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625036,
      kugou: 140398653,
      kuwo: 66622295
    },
    imgUrl: 'H5_10.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/002DxVU93awmjT.html',
      kugou: 'http://www.kugou.com/yy/singer/776487.html',
      kuwo: 'http://www.kuwo.cn/mingxing/JD%5B%E7%94%B7%5D/'
    },
    singerId: {
      qqyin: '2106204',
      kugou: '776487',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  },
  {
    id: {
      qqyin: 230625026,
      kugou: 140398683,
      kuwo: 66622067
    },
    imgUrl: 'H5_11.png',
    singerUrl: {
      qqyin: 'https://y.qq.com/n/yqq/singer/000AXkD20ksV2v.html',
      kugou: 'https://www.kugou.com/singer/195023.html',
      kuwo: 'http://www.kuwo.cn/mingxing/%E8%AE%B8%E5%93%B2/'
    },
    singerId: {
      qqyin: '1017066',
      kugou: '195023',
      kuwo: ''
    },
    albumId: {
      qqyin: '',
      kugou: ''
    }
  }
]